module.exports = __webpack_public_path__ + "media/AUDIO 05.d721f7ea.mp3";